/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class FileUploadModel {

        public fileUploadProgress: number;
        public errorMessage: string;
        public documents: Wars.Domain.Model.Dtos.DocumentDto[];

        public systemLevelId: string;
        public processConfigId: string;
    }
}